import { render, staticRenderFns } from "./TifLegendInfo.vue?vue&type=template&id=a07e929e"
import script from "./TifLegendInfo.vue?vue&type=script&lang=js"
export * from "./TifLegendInfo.vue?vue&type=script&lang=js"
import style0 from "./TifLegendInfo.vue?vue&type=style&index=0&id=a07e929e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports